import { message } from 'antd'
import { HEADER_HEIGHT } from 'modules/core/constants'
message.config({
	top: HEADER_HEIGHT + 10,
	duration: 3,
	maxCount: 3
})
